import { SET_TRANSACTION_BID_DROPDOWN_VALUE } from "../action";

export function setTransactionBidDropdownValue(domainName, domainValue) {
  return (dispatch) => {
    dispatch({
      type: SET_TRANSACTION_BID_DROPDOWN_VALUE,
      payload: { domainName, domainValue },
    });
  };
}
